<template>
    <div>
        <div class="sec_copyright">
            <div class="sec_mbox sec_copyrightBox clearfix">
                <div class="sec_copyrightF">
                    <p class="sec_copyrightTitle">平台描述</p>
                    <p class="sec_copyrightCon">中国反网络病毒联盟全称为中国互联网协会反网络病毒联盟，中文简称“联盟”，英文简称“ANVA”。ANVA通过行业自律机制推动互联网网络病毒的防范、治理工作，净化网络空间，维护公共互联网网络安全。
                    </p>
                </div>
                <div class="sec_copyrightS">
                    <p class="sec_copyrightTitle">导航</p>
                    <ul style="margin-bottom: 0px;">
                        <li><a href="/index">首页</a>
                        </li>
                        <li><a href="/html/introduce">业务介绍</a>
                        </li>
                        <li><a href="/html/alliance/introduce">联盟信息</a>
                        </li>
                        <li><a href="/alliance/list?typeFlag=201">联盟动态</a>
                        </li>
                        <li><a href="/html/evaluation/background">安全认证</a>
                        </li>
                        <li><a href="/html/safetools/virus">安全科普</a>
                        </li>
                    </ul>
                </div>
                <div class="sec_copyrightT">
                    <p class="sec_copyrightTitle">合作伙伴</p>
                    <ul>
                        <li><a href="https://share.anva.org.cn">网络安全威胁信息共享平台</a>
                        </li>
                        <li><a href="https://appstore.anva.org.cn">移动APP预置与分发渠道安全检测平台</a>
                        </li>
                        <li><a href="https://white.anva.org.cn">移动互联网应用自律白名单发布平台</a>
                        </li>
                        <li><a href="https://ca.anva.org.cn">移动互联网应用程序开发者数字证书管理平台</a>
                        </li>
                    </ul>
                </div>
                <div class="sec_copyrightW">
                    <p class="sec_copyrightTitle">关注我们</p>
                    <ul class="clearfix">
                        <li><img src="/image/anva/secxl.png">
                            <p class="sec_wxxl">新浪微博</p></li>
                        <li style="margin-right: 0px;"><img src="/image/anva/secwx.png">
                            <p class="sec_wxxl">微信公众号</p></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="sec_foot">
            <div class="sec_mbox clearfix">
                <p class="sec_footZ">主办：中国反网络病毒联盟</p>
                <p class="sec_footI"><a href="http://www.miibeian.gov.cn" target="_blank" class="g_icpBtn">ICP:京10012421号</a></p>
                <p class="sec_footE">如有问题请联系&nbsp;&nbsp;&nbsp;&nbsp;anvaregister@cert.org.cn</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'anva-copyright'
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/style/anva/base";
    @import "~@/assets/style/anva/style";
</style>